export default __webpack_public_path__ + "static/media/6.19f9ee98.jpg";